export default __webpack_public_path__ + "static/media/content.13fde8d5.md";